import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  trend?: {
    value: number;
    label: string;
  };
  loading?: boolean;
  color?: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  trend,
  loading = false,
  color,
}) => {
  if (loading) {
    return (
      <div data-testid="dashboard-stats-card" className="bg-white rounded-card border border-border p-4 animate-pulse">
        <div className="h-4 w-24 bg-gray-200 rounded mb-3" />
        <div className="h-8 w-16 bg-gray-200 rounded mb-2" />
        <div className="h-3 w-20 bg-gray-200 rounded" />
      </div>
    );
  }

  const iconColor = color || '#0a7a72';

  return (
    <div data-testid="dashboard-stats-card" className="bg-white rounded-card border border-border p-4 h-full">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-text-primary">{title}</p>
          <p className="text-3xl font-bold text-text-primary my-2">{value}</p>
          {subtitle && (
            <p className="text-xs text-text-primary">{subtitle}</p>
          )}
        </div>
        {icon && (
          <div
            className="w-[44px] h-[44px] rounded-[10px] flex-shrink-0 flex items-center justify-center"
            style={{ backgroundColor: '#F0FDFA', color: iconColor }}
          >
            {icon}
          </div>
        )}
      </div>

      {trend && (
        <div className="flex items-center mt-3 gap-1">
          {trend.value >= 0 ? (
            <TrendingUp className="h-4 w-4 text-green-600" />
          ) : (
            <TrendingDown className="h-4 w-4 text-red-500" />
          )}
          <span className={`text-sm font-semibold ${trend.value >= 0 ? 'text-green-700' : 'text-red-600'}`}>
            {trend.value > 0 ? '+' : ''}{trend.value}%
          </span>
          <span className="text-sm text-text-primary">{trend.label}</span>
        </div>
      )}
    </div>
  );
};
